import ListFormItem from "@arelia-components/form/ListFormItem";
import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import { SubscriptionPlan, SubscriptionPlanName } from "@arelia-types/subscriptions";
import { List } from "@mui/material";
import { Box } from "@mui/system";
import { DesktopDatePicker } from "@mui/x-date-pickers";

type Props = {
  plan: SubscriptionPlan | undefined;
  setPlan: (plan: SubscriptionPlan | undefined) => void;
  expDate: Date;
  setExpDate: (expDate: Date) => void;
};

export default function EditPlan({ expDate, plan, setExpDate, setPlan }: Props) {
  const innerPlan = ![SubscriptionPlanName.Premium, SubscriptionPlanName.PremiumMyFans].includes(plan as SubscriptionPlanName) ? null : plan;
  const tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 1));

  return <List sx={styles.list}>
    <ListFormItem label="Plan" sx={{ display: "flex" }}>
      <Box sx={styles.selection} >
        <MenuSelector
          menuType={MenuType.outlined}
          menuItems={[
            { label: 'Select Plan', value: null, disabled: true }, 
            { label: `Free ${SubscriptionPlanName.Premium} plan`, value: SubscriptionPlanName.Premium },
            { label: `Free Premium + My Fans plan`, value: SubscriptionPlanName.PremiumMyFans }
          ]}
          selectedValue={innerPlan}
          onClick={setPlan}
        />
        <DesktopDatePicker
          label="Expiration date"
          value={expDate}
          minDate={tomorrowDate}
          onChange={(val) => val && setExpDate(val)}
          sx={styles.picker}
        />
      </Box>
    </ListFormItem>
  </List>
}

const styles = {
  list: {
    width: "100%"
  },
  selection: {
    display: "flex",
    alignItems: "center",
    gap: "20px"
  },
  picker: {
    width: '40%',
    '& .MuiInputBase-input': {
      paddingY: '8px'
    }
  }
}
